__turbopack_context__.v({
  "closeBtn": "EnquiryModal-module__fDvqna__closeBtn",
  "counter": "EnquiryModal-module__fDvqna__counter",
  "cutPrice": "EnquiryModal-module__fDvqna__cutPrice",
  "dateIcon": "EnquiryModal-module__fDvqna__dateIcon",
  "dateInput": "EnquiryModal-module__fDvqna__dateInput",
  "dateWrap": "EnquiryModal-module__fDvqna__dateWrap",
  "discountPill": "EnquiryModal-module__fDvqna__discountPill",
  "errorText": "EnquiryModal-module__fDvqna__errorText",
  "field": "EnquiryModal-module__fDvqna__field",
  "fieldLabel": "EnquiryModal-module__fDvqna__fieldLabel",
  "form": "EnquiryModal-module__fDvqna__form",
  "formGrid": "EnquiryModal-module__fDvqna__formGrid",
  "headerCard": "EnquiryModal-module__fDvqna__headerCard",
  "input": "EnquiryModal-module__fDvqna__input",
  "inputError": "EnquiryModal-module__fDvqna__inputError",
  "modal": "EnquiryModal-module__fDvqna__modal",
  "modalDesktop": "EnquiryModal-module__fDvqna__modalDesktop",
  "modalMobile": "EnquiryModal-module__fDvqna__modalMobile",
  "modalTopBar": "EnquiryModal-module__fDvqna__modalTopBar",
  "overlay": "EnquiryModal-module__fDvqna__overlay",
  "packageInfo": "EnquiryModal-module__fDvqna__packageInfo",
  "packageRow": "EnquiryModal-module__fDvqna__packageRow",
  "phoneField": "EnquiryModal-module__fDvqna__phoneField",
  "plus": "EnquiryModal-module__fDvqna__plus",
  "priceAside": "EnquiryModal-module__fDvqna__priceAside",
  "priceNow": "EnquiryModal-module__fDvqna__priceNow",
  "root": "EnquiryModal-module__fDvqna__root",
  "rootDesktop": "EnquiryModal-module__fDvqna__rootDesktop",
  "rootMobile": "EnquiryModal-module__fDvqna__rootMobile",
  "select": "EnquiryModal-module__fDvqna__select",
  "sheetUp": "EnquiryModal-module__fDvqna__sheetUp",
  "slab": "EnquiryModal-module__fDvqna__slab",
  "submitBtn": "EnquiryModal-module__fDvqna__submitBtn",
  "subtitle": "EnquiryModal-module__fDvqna__subtitle",
  "summary": "EnquiryModal-module__fDvqna__summary",
  "thumb": "EnquiryModal-module__fDvqna__thumb",
  "title": "EnquiryModal-module__fDvqna__title",
});
